import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 41.22 21.69"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("mask", {
        id: "svg-LY-logo_svg__a",
        width: "41.22",
        height: "21.69",
        x: "0",
        y: "0",
        maskUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("path", {
          d: "M2.84 15.5h30.24c.55 0 .79.49.53 1.09l-1.27 2.99c-.25.6-.9 1.09-1.46 1.09H.63c-.55 0-.79-.49-.53-1.09l1.27-2.99c.26-.6.91-1.09 1.46-1.09ZM10.21 0h30.25c.55 0 .79.48.53 1.08l-1.27 2.99c-.26.6-.91 1.09-1.46 1.09H8.01c-.55 0-.79-.48-.53-1.09l1.27-2.99C9.01.48 9.66 0 10.21 0Zm10.97 6.57.56 1.5h2.1c.45 0 .54.35.12.86l-1.32 1.56.54 1.46c.12.33.16.68-.61.68h-1.75l-1.32 1.56c-.33.38-.44.39-.62-.08l-.55-1.47H16.2c-.45 0-.55-.36-.12-.86l1.35-1.59-.53-1.43c-.12-.32-.16-.68.6-.68h1.72l1.35-1.59c.33-.39.44-.4.62.09Z",
          "data-name": "mask1 4628 86352",
          style: {"fill":"#fff"}
        })
      ])
    ], -1),
    _createElementVNode("g", { style: {"mask":"url(#svg-LY-logo_svg__a)"} }, [
      _createElementVNode("path", {
        d: "M41.22 0H0v21.69h41.22V0Z",
        style: {"fill":"#1b358f"}
      })
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LY-logo"}) } }